export const FIELD_NAMES = {
  // Draft fields
  ID: '_id',
  PHARMACY: 'pharmacy',
  PARTNER: 'partner',
  CUSTOM_PARTNER: 'custom_partner',
  POC_NAME: 'poc_name',
  STATUS: 'status',
  CREATED_AT: 'created_at',

  // Medicine fields
  MEDICINE_ID: 'medicine_id',
  MEDICINE_NAME: 'medicine_name',
  MANUFACTURER: 'manufacturer',
  PRICE: 'price',
  QUANTITY: 'quantity',
  DISCOUNT: 'discount',
  BATCH: 'batch',
  EXPIRY: 'expiry',
  PACKING_SIZE: 'packing_size',
  DISCOUNT_TIER: 'discount_tier',

  // Customer fields
  CUSTOMER: 'customer',
  NAME: 'name',
  MOBILE: 'mobile',
  ADDRESS_DETAILS: 'address_details',
  ADDRESS: 'address',
  PINCODE: 'pincode',
  LATITUDE: 'latitude',
  LONGITUDE: 'longitude',

  // Charge fields
  CHARGE_TYPE: 'charge_type',
  AMOUNT: 'amount'
};

export const DEFAULT_VALUES = {
  PENDING: 'pending',
  EMPTY_STRING: '',
  ZERO: 0,
  DEFAULT_BATCH: 'Pending'
}; 